import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=1409317e"
import script from "./Params.vue?vue&type=script&lang=ts&setup=true"
export * from "./Params.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Params.vue?vue&type=style&index=0&id=1409317e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports